/* eslint-disable no-unused-vars */
// needed since color isn't used in the template but appears in the replaced body
import React from "react";
import PropTypes from "prop-types";

/*
 * Yuka v2.0
 * This component corresponds to ``calendar.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */
const CalendarIcon = ({ color, size }) => (
  <svg width={size} height={size} viewBox="0 0 18 18">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        fill={color}
        fillRule="evenodd"
        d="M6 0.75C6.41421 0.75 6.75 1.08579 6.75 1.5V2.25H11.25V1.5C11.25 1.08579 11.5858 0.75 12 0.75C12.4142 0.75 12.75 1.08579 12.75 1.5V2.25122C13.1066 2.25367 13.4183 2.26104 13.6889 2.28315C14.1104 2.31759 14.498 2.39151 14.862 2.57698C15.4265 2.8646 15.8854 3.32354 16.173 3.88803C16.3585 4.25203 16.4324 4.63956 16.4669 5.06113C16.5 5.46702 16.5 5.96529 16.5 6.56901V12.931C16.5 13.5347 16.5 14.033 16.4669 14.4389C16.4324 14.8604 16.3585 15.248 16.173 15.612C15.8854 16.1765 15.4265 16.6354 14.862 16.923C14.498 17.1085 14.1104 17.1824 13.6889 17.2169C13.283 17.25 12.7847 17.25 12.181 17.25H5.81901C5.21529 17.25 4.71702 17.25 4.31113 17.2169C3.88956 17.1824 3.50203 17.1085 3.13803 16.923C2.57354 16.6354 2.1146 16.1765 1.82698 15.612C1.64151 15.248 1.56759 14.8604 1.53315 14.4389C1.49998 14.033 1.49999 13.5347 1.5 12.931V6.56903C1.49999 5.9653 1.49998 5.46703 1.53315 5.06113C1.56759 4.63956 1.64151 4.25203 1.82698 3.88803C2.1146 3.32354 2.57354 2.8646 3.13803 2.57698C3.50203 2.39151 3.88956 2.31759 4.31113 2.28315C4.58174 2.26104 4.8934 2.25367 5.25 2.25122V1.5C5.25 1.08579 5.58579 0.75 6 0.75ZM5.25 3.75132C4.91585 3.75367 4.65347 3.76017 4.43328 3.77816C4.10447 3.80503 3.93631 3.85372 3.81902 3.91349C3.53677 4.0573 3.3073 4.28677 3.16349 4.56901C3.10372 4.68631 3.05503 4.85447 3.02816 5.18328C3.00058 5.52085 3 5.95757 3 6.6V6.75H15V6.6C15 5.95757 14.9994 5.52085 14.9718 5.18328C14.945 4.85447 14.8963 4.68631 14.8365 4.56901C14.6927 4.28677 14.4632 4.0573 14.181 3.91349C14.0637 3.85372 13.8955 3.80503 13.5667 3.77816C13.3465 3.76017 13.0841 3.75367 12.75 3.75132V4.5C12.75 4.91421 12.4142 5.25 12 5.25C11.5858 5.25 11.25 4.91421 11.25 4.5V3.75H6.75V4.5C6.75 4.91421 6.41421 5.25 6 5.25C5.58579 5.25 5.25 4.91421 5.25 4.5V3.75132ZM15 8.25H3V12.9C3 13.5424 3.00058 13.9792 3.02816 14.3167C3.05503 14.6455 3.10372 14.8137 3.16349 14.931C3.3073 15.2132 3.53677 15.4427 3.81902 15.5865C3.93631 15.6463 4.10447 15.695 4.43328 15.7218C4.77085 15.7494 5.20757 15.75 5.85 15.75H12.15C12.7924 15.75 13.2292 15.7494 13.5667 15.7218C13.8955 15.695 14.0637 15.6463 14.181 15.5865C14.4632 15.4427 14.6927 15.2132 14.8365 14.931C14.8963 14.8137 14.945 14.6455 14.9718 14.3167C14.9994 13.9792 15 13.5424 15 12.9V8.25Z"
        transform=""
      />
    </g>
  </svg>
);

CalendarIcon.propTypes = {
  // all of these can be overriden in CSS as necessary
  color: PropTypes.string,
  size: PropTypes.number,
};

CalendarIcon.defaultProps = {
  color: "#ffffff",
  size: 16,
};

CalendarIcon.displayName = "CalendarIcon";

export default CalendarIcon;
